import pt from '../JsonLang/pt.json'
export const lang = { ...pt }